// extracted by mini-css-extract-plugin
module.exports = {"item_list_main":"Category_item_list_main__2HT74","item_list":"Category_item_list__3f75O","item_main":"Category_item_main__1GZt6","icon":"Category_icon__-pol4"};